export default "__VITE_ASSET__DIulTPaa__"